export default __webpack_public_path__ + "0e0770e4ae033a14f6bb41ca3c40c31a.png";